// TODO: replace string literals with variables - (phyoh)
import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  MODIFY_SECURITY_DEPOSIT: '2531',
  VERIFY_INCOME: '2532',
  CREATE_LEASE: '2533',
  SETUP_PAYMENTS: '2534',
  SAMPLE_INSURANCE_POLICY: '2535',
  DROP_RENTAL_PROTECTION: '2536',
  CONFIRM_DROP_RENTAL_PROTECTION: '2537',
  HOW_TO_FILE_CLAIM: '2538',
  CONTINUE_FILE_CLAIM: '2539',
  CANCEL_POLICY: '2602',
  VIEW_COVERAGE_SUMMARY: '3150',
  VIEW_FAQS: '3151',
  CANCEL_POLICY_CONTINUE: '3152',
  CANCEL_POLICY_CONFIRM: '3153',
  RESUME_DROPPED_REQUEST: '3170',
  CONFIRM_RESUME_DROPPED_REQUEST: '3171',
  RENEW_COVERAGE_MANAGE_DROP_DOWN_MENU: '5084',
  RENEW_COVERAGE_NOTIFICATION_BANNER: '5085',
  SELECT_LEASE_BUTTON: '5623',
  PAY_FOR_POLICY_BUTTON: '6113',
  PAY_FOR_YOUR_POLICY_OVERVIEW_CONTINUE_BUTTON: '5626',
  SUBMIT_STRIPE_PAYMENT: '5627',
  HOW_TO_PURCHASE_RENTAL_PROTECTION: '6407',
  RENT_COLLECTION_METHOD_LOW_FRICTION: '6512',
} as const;

type CSEventParams = {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
};

// https://dataportal.zillowgroup.net/event-registry/2531
const ModifySecurityDeposit = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.MODIFY_SECURITY_DEPOSIT,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'change_security_deposit',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2532
const VerifyIncome = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VERIFY_INCOME,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'verify_income',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2533
const CreateLease = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CREATE_LEASE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'create_lease',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2534
const SetupPayments = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SETUP_PAYMENTS,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'setup_payments',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2535
const SampleInsurancePolicy = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SAMPLE_INSURANCE_POLICY,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'sample_insurance_policy',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2536
const DropRentalProtection = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.DROP_RENTAL_PROTECTION,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'drop_rental_protection_request',
    },
    semantic: {
      semantic_event_nm: 'drop_rental_protection_request_start',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2537
const ConfirmDropRentalProtection = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CONFIRM_DROP_RENTAL_PROTECTION,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'yes_drop_request',
    },
    semantic: {
      semantic_event_nm: 'drop_rental_protection_request_confirm',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2538
const HowToFileClaim = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.HOW_TO_FILE_CLAIM,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'how_to_file_claim',
    },
    semantic: {
      semantic_event_nm: 'file_claim_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2539
const ContinueFileClaim = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CONTINUE_FILE_CLAIM,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'continue_file_claim',
    },
    semantic: {
      semantic_event_nm: 'file_claim_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2602
const CancelPolicy = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CANCEL_POLICY,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'cancel_policy',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3150
const ViewCoverageSummary = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_COVERAGE_SUMMARY,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'coverage_summary',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3151
const ViewFaqs = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_FAQS,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'frequently_asked_questions',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3152
const CancelPolicyContinue = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CANCEL_POLICY_CONTINUE,
      event_type_version_id: '3',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'cancel_policy_modal',
      trigger_source_nm: 'continue',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3153
const CancelPolicyConfirm = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CANCEL_POLICY_CONFIRM,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'cancel_policy_modal',
      trigger_source_nm: 'confirm',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3170
const ResumeDroppedRequest = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.RESUME_DROPPED_REQUEST,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'resume_your_request',
    },
    semantic: {
      semantic_event_nm: 'resume_dropped_rental_protection_request',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3171
const ConfirmResumeDroppedRequest = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CONFIRM_RESUME_DROPPED_REQUEST,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'resume_request_modal',
      trigger_source_nm: 'confirm',
    },
    semantic: {
      semantic_event_nm: 'resume_dropped_rental_protection_request',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5084
const RenewCoverageManageDropDownMenu = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.RENEW_COVERAGE_MANAGE_DROP_DOWN_MENU,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'manage_dropdown_menu',
      trigger_source_nm: 'start_renewal',
    },
    semantic: {
      semantic_event_nm: 'renew_rental_protection_coverage',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5085
const RenewCoverageNotificationBanner = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.RENEW_COVERAGE_NOTIFICATION_BANNER,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'renew_coverage_banner',
      trigger_source_nm: 'start_renewal',
    },
    semantic: {
      semantic_event_nm: 'renew_rental_protection_coverage',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5623
const SelectLeaseButton = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SELECT_LEASE_BUTTON,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'lease_selector_modal',
      trigger_source_nm: 'create_new_lease',
    },
    semantic: {
      semantic_event_nm: 'create_new_lease_manage_rental_protection',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6113
const PayForPolicyButton = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.PAY_FOR_POLICY_BUTTON,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'pay',
    },
    semantic: {
      semantic_event_nm: 'pay_manage_rental_protection',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5626
const PayForYourPolicyOverviewContinueButton = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.PAY_FOR_YOUR_POLICY_OVERVIEW_CONTINUE_BUTTON,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'setup_payment_modal',
      trigger_source_nm: 'continue_paying_policy',
    },
    semantic: {
      semantic_event_nm: 'continue_pay_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/5627
const SubmitStripePayment = ({ currentProperty, user }: CSEventParams) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SUBMIT_STRIPE_PAYMENT,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'setup_payment_modal',
      trigger_source_nm: 'submit_payment',
    },
    semantic: {
      semantic_event_nm: 'submit_pay_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6407
const HowToPurchaseRentalProtection = () =>
  trackEvent.base({
    envelope: {
      event_template_id: '171',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.HOW_TO_PURCHASE_RENTAL_PROTECTION,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'how_to_purchase',
    },
    semantic: {
      semantic_event_nm: 'how_to_purchase_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
  });

// https://dataportal.zillowgroup.net/event-registry/6512
const RentCollectionMethodLowFriction = (trigger_source_nm: string) =>
  trackEvent.base({
    envelope: {
      event_template_id: '171',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.RENT_COLLECTION_METHOD_LOW_FRICTION,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'rental_protection_manage_policy',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: trigger_source_nm,
    },
    semantic: {
      semantic_event_nm: 'rent_collection_method_low_friction',
      topic_tag_txt: ['zrm_rental_protection'],
    },
  });

const ManagePolicyCSEvents = {
  ModifySecurityDeposit,
  VerifyIncome,
  CreateLease,
  SetupPayments,
  SampleInsurancePolicy,
  DropRentalProtection,
  ConfirmDropRentalProtection,
  CancelPolicy,
  HowToFileClaim,
  ContinueFileClaim,
  ViewCoverageSummary,
  ViewFaqs,
  CancelPolicyContinue,
  CancelPolicyConfirm,
  ResumeDroppedRequest,
  ConfirmResumeDroppedRequest,
  RenewCoverageManageDropDownMenu,
  RenewCoverageNotificationBanner,
  SelectLeaseButton,
  PayForPolicyButton,
  PayForYourPolicyOverviewContinueButton,
  SubmitStripePayment,
  HowToPurchaseRentalProtection,
  RentCollectionMethodLowFriction,
};

// Clickstream visualizer data-eventid attributes
ModifySecurityDeposit.data_event_id = EVENT_IDS.MODIFY_SECURITY_DEPOSIT;
VerifyIncome.data_event_id = EVENT_IDS.VERIFY_INCOME;
CreateLease.data_event_id = EVENT_IDS.CREATE_LEASE;
SetupPayments.data_event_id = EVENT_IDS.SETUP_PAYMENTS;
SampleInsurancePolicy.data_event_id = EVENT_IDS.SAMPLE_INSURANCE_POLICY;
DropRentalProtection.data_event_id = EVENT_IDS.DROP_RENTAL_PROTECTION;
ConfirmDropRentalProtection.data_event_id = EVENT_IDS.CONFIRM_DROP_RENTAL_PROTECTION;
CancelPolicy.data_event_id = EVENT_IDS.CANCEL_POLICY;
HowToFileClaim.data_event_id = EVENT_IDS.HOW_TO_FILE_CLAIM;
ContinueFileClaim.data_event_id = EVENT_IDS.CONTINUE_FILE_CLAIM;
ViewCoverageSummary.data_event_id = EVENT_IDS.VIEW_COVERAGE_SUMMARY;
ViewFaqs.data_event_id = EVENT_IDS.VIEW_FAQS;
CancelPolicyContinue.data_event_id = EVENT_IDS.CANCEL_POLICY_CONTINUE;
CancelPolicyConfirm.data_event_id = EVENT_IDS.CANCEL_POLICY_CONFIRM;
ResumeDroppedRequest.data_event_id = EVENT_IDS.RESUME_DROPPED_REQUEST;
ConfirmResumeDroppedRequest.data_event_id = EVENT_IDS.CONFIRM_RESUME_DROPPED_REQUEST;
RenewCoverageManageDropDownMenu.data_event_id = EVENT_IDS.RENEW_COVERAGE_MANAGE_DROP_DOWN_MENU;
RenewCoverageNotificationBanner.data_event_id = EVENT_IDS.RENEW_COVERAGE_NOTIFICATION_BANNER;
SelectLeaseButton.data_event_id = EVENT_IDS.SELECT_LEASE_BUTTON;
PayForPolicyButton.data_event_id = EVENT_IDS.PAY_FOR_POLICY_BUTTON;
PayForYourPolicyOverviewContinueButton.data_event_id = EVENT_IDS.PAY_FOR_YOUR_POLICY_OVERVIEW_CONTINUE_BUTTON;
SubmitStripePayment.data_event_id = EVENT_IDS.SUBMIT_STRIPE_PAYMENT;
HowToPurchaseRentalProtection.data_event_id = EVENT_IDS.HOW_TO_PURCHASE_RENTAL_PROTECTION;
RentCollectionMethodLowFriction.data_event_id = EVENT_IDS.RENT_COLLECTION_METHOD_LOW_FRICTION;

export default ManagePolicyCSEvents;
